// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3juGF","containerItemsCenter":"Skeleton_containerItemsCenter__f0GEJ"};